import findControlsFor from './find-controls-for';

export default {
  findControlsFor,
};
